import { Box, Divider, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import Textfield from "../../shared/textfield";
import { title } from "../../../style2";


export default function PregnancyBirthHistory(props) {
  const [disabledField, setDisabledField] = useState(true);

  // const handleEdit = () => {
  //   setDisabledField(!disabledField);
  //   if (!disabledField) {
  //     // To save changes here
  //   }
  // };

  // const handleCancelEdit = () => {
  //   setDisabledField(true);
  // };

  const profile = props.profile;


  return (
    <Box ml={2} mr={2} mb={2}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={title}>Pregnancy</Typography>
        </Grid>
        {profile.maternalBirthHistory?.prenatalHistory && profile.maternalBirthHistory?.prenatalHistory !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='Prenatal history'
              value={profile.maternalBirthHistory?.prenatalHistory}
              disabled={disabledField}
              multiline
              rows={2}
            />
          </Grid> : null}
        {profile.maternalBirthHistory?.maternalHealthDuringPregnancy && profile.maternalBirthHistory?.maternalHealthDuringPregnancy !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='Maternal health during pregnancy'
              value={profile.maternalBirthHistory?.maternalHealthDuringPregnancy}
              disabled={disabledField}
              multiline
              rows={2}
            />
          </Grid> : null}
        {profile.maternalBirthHistory?.birthHistory && profile.maternalBirthHistory?.birthHistory !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='Birth history (labor and delivery)'
              value={profile.maternalBirthHistory?.birthHistory}
              disabled={disabledField}
              multiline
              rows={2}
            />
          </Grid> : null}
        {profile.maternalBirthHistory?.gestationalAgeAtDelivery && profile.maternalBirthHistory?.gestationalAgeAtDelivery !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='Gestational age at delivery'
              value={profile.maternalBirthHistory?.gestationalAgeAtDelivery}
              disabled={disabledField}
              multiline
              rows={2}
            />
          </Grid> : null
        }
        {profile.maternalBirthHistory?.deliveryType && profile.maternalBirthHistory?.deliveryType !== "" ?
          <Grid item xs={12}>
            <Textfield title='Delivery Type' value={profile.maternalBirthHistory?.deliveryType} disabled={disabledField} />
          </Grid> : null}
        {profile.maternalBirthHistory?.babyWeight && profile.maternalBirthHistory?.babyWeight !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='Weight of baby when born'
              value={profile.maternalBirthHistory?.babyWeight}
              disabled={disabledField}
              multiline
              rows={2}
            />
          </Grid> : null}
        {profile.maternalBirthHistory?.neonatalHistory && profile.maternalBirthHistory?.neonatalHistory !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='Neonatal history/period'
              value={profile.maternalBirthHistory?.neonatalHistory}
              disabled={disabledField}
              multiline
              rows={2}
            />
          </Grid> : null}
        {profile.maternalBirthHistory?.hospitalHistorySinceBirth && profile.maternalBirthHistory?.hospitalHistorySinceBirth !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='Hospital history since birth'
              value={profile.maternalBirthHistory?.hospitalHistorySinceBirth}
              disabled={disabledField}
              multiline
              rows={2}
            />
          </Grid> : null}
      </Grid>
      <Box m={2} />
      {profile.maternalBirthHistory?.feedingHistory && profile.maternalBirthHistory?.feedingHistory !== "" ?
        <>
          <Divider />
          <Box m={2} />
          <Grid container spacing={2}>
            <Grid item xs={12}> <Typography sx={title}>Feeding History</Typography> </Grid>
            <Grid item xs={12}>
              <Textfield title='Feeding History' value={profile.maternalBirthHistory?.feedingHistory} disabled={disabledField} multiline />
            </Grid>
          </Grid>
        </> : null}
    </Box>
  );
}
